import VoilaConfig from '../config';
import axios from 'axios';
import qs from 'qs';

export const REQUEST_POSTS = 'REQUEST_SEARCH';
export const RECEIVE_POSTS = 'RECEIVE_SEARCH';
export const SELECT_SEARCH = 'SELECT_SEARCH';
export const INVALIDATE_SEARCH = 'INVALIDATE_SEARCH';

export function selectSearch(searchQuery) {
  return {
    type: SELECT_SEARCH,
    searchQuery
  };
}

export function invalidateSearch(searchQuery) {
  return {
    type: INVALIDATE_SEARCH,
    searchQuery
  };
}

function requestPosts(searchQuery) {
  return {
    type: REQUEST_POSTS,
    searchQuery
  };
}

function receivePosts(searchQuery, json) {
  return {
    type: RECEIVE_POSTS,
    searchQuery,
    posts: json.map(child => child),
    receivedAt: Date.now()
  };
}

function fetchPosts(searchQuery) {
  return dispatch => {
    dispatch(requestPosts(searchQuery));

    const queryParams = {
      per_page: 100,
      search: searchQuery,
      type: ['album', 'genre', 'instrument', 'keyword', 'mood', 'product', 'style'],
    };

    const queryString = qs.stringify(queryParams);
    const searchUrl = `${VoilaConfig.API_URL}/wp/v2/posts?${queryString}`;

    return axios.get(searchUrl).then(response => {
      const data = response.data || [];

      dispatch(receivePosts(searchQuery, data));
    });
  };
}

function shouldFetchPosts(state, searchQuery) {
  const posts = state.search[searchQuery];

  if (!posts) {
    return true;
  } else if (posts.isFetching) {
    return false;
  } else {
    return posts.didInvalidate;
  }
}

export function fetchPostsIfNeeded(searchQuery) {
  return (dispatch, getState) => {
    if (shouldFetchPosts(getState(), searchQuery)) {
      return dispatch(fetchPosts(searchQuery));
    }
  };
}


// WEBPACK FOOTER //
// ./src/actions/SearchActions.js